import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ss-margin-campos" }
const _hoisted_2 = {
  class: "ant-row",
  style: {"margin-bottom":"10px"}
}
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-16" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("strong", null, "Total dos Tributos:", -1)
const _hoisted_5 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-8",
  style: {"text-align":"right"}
}
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_13 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_14 = { class: "ant-row" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_17 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_21 = { class: "ant-row" }
const _hoisted_22 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_25 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_26 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_27 = { class: "ant-row" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }
const _hoisted_31 = { class: "ant-col ant-col-xs-12 ant-col-xl-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.formatarNumero(_ctx.state.imposto.valorTotalTributosAproximado)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.props.editavel)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.aplicarCenarioFiscal && _ctx.aplicarCenarioFiscal(...args)))
            }, " Aplicar cenário fiscal "))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_a_form, { layout: "vertical" }, {
      default: _withCtx(() => [
        _createVNode(_component_card, { titulo: "ICMS" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_a_form_item, {
                  label: "CST ICMS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "ant-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.imposto.icms.cstIcms) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, _hoisted_8), [
                      [_vModelText, _ctx.state.imposto.icms.cstIcms]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_a_form_item, {
                  label: "Base ICMS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      fracionar: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.icms.baseCalculo,
                      "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.imposto.icms.baseCalculo) = $event)),
                      disabled: !_ctx.props.editavel,
                      onChange: _ctx.calcularValorIcms
                    }, null, 8, ["valor", "disabled", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_a_form_item, {
                  label: "Alíquota ICMS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      percentual: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.icms.aliquota,
                      "onUpdate:valor": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.imposto.icms.aliquota) = $event)),
                      disabled: !_ctx.props.editavel,
                      onChange: _ctx.calcularValorIcms
                    }, null, 8, ["valor", "disabled", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_a_form_item, {
                  label: "Valor ICMS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.icms.valorIcms,
                      "onUpdate:valor": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.imposto.icms.valorIcms) = $event)),
                      disabled: !_ctx.props.editavel,
                      onChange: _ctx.atualizarTotalTributos
                    }, null, 8, ["valor", "disabled", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_a_form_item, {
                  label: "Base ST",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.icms.valorBaseCalculoSt,
                      "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.imposto.icms.valorBaseCalculoSt) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, ["valor", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_a_form_item, {
                  label: "Valor ST",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.icms.valorIcmsSt,
                      "onUpdate:valor": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.imposto.icms.valorIcmsSt) = $event)),
                      disabled: !_ctx.props.editavel,
                      onChange: _ctx.atualizarTotalTributos
                    }, null, 8, ["valor", "disabled", "onChange"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_card, { titulo: "ISS" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_form_item, {
                  label: "Base ISS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.iss.baseCalculo,
                      "onUpdate:valor": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.imposto.iss.baseCalculo) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, ["valor", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_a_form_item, {
                  label: "Alíquota ISS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      percentual: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.iss.aliquota,
                      "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.imposto.iss.aliquota) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, ["valor", "disabled"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_form_item, {
                  label: "Valor ISS",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      monetario: true,
                      quantidadeCasasDecimais: 2,
                      valor: _ctx.state.imposto.iss.valorIss,
                      "onUpdate:valor": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.imposto.iss.valorIss) = $event)),
                      disabled: !_ctx.props.editavel,
                      onChange: _ctx.atualizarTotalTributos
                    }, null, 8, ["valor", "disabled", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_a_form_item, {
                  label: "Município Fato Gerador",
                  class: "ss-margin-campos"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_campo_numerico, {
                      valor: _ctx.state.imposto.iss.codigoMunicipioFatoGerador,
                      "onUpdate:valor": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.imposto.iss.codigoMunicipioFatoGerador) = $event)),
                      disabled: !_ctx.props.editavel
                    }, null, 8, ["valor", "disabled"])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_card, { titulo: "PIS / COFINS" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_a_form_item, {
                      label: "PIS CST",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.imposto.pis.cstPis) = $event)),
                          disabled: !_ctx.props.editavel
                        }, null, 8, _hoisted_23), [
                          [_vModelText, _ctx.state.imposto.pis.cstPis]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_a_form_item, {
                      label: "PIS Alíquota",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          percentual: true,
                          quantidadeCasasDecimais: 2,
                          valor: _ctx.state.imposto.pis.aliquota,
                          "onUpdate:valor": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.imposto.pis.aliquota) = $event)),
                          disabled: !_ctx.props.editavel
                        }, null, 8, ["valor", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createVNode(_component_a_form_item, {
                      label: "PIS Valor",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          quantidadeCasasDecimais: 2,
                          valor: _ctx.state.imposto.pis.valorPis,
                          "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.imposto.pis.valorPis) = $event)),
                          disabled: !_ctx.props.editavel,
                          onChange: _ctx.atualizarTotalTributos
                        }, null, 8, ["valor", "disabled", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_a_form_item, {
                      label: "COFINS CST",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.imposto.cofins.cstCofins) = $event)),
                          disabled: !_ctx.props.editavel
                        }, null, 8, _hoisted_29), [
                          [_vModelText, _ctx.state.imposto.cofins.cstCofins]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_a_form_item, {
                      label: "COFINS Alíquota",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          percentual: true,
                          quantidadeCasasDecimais: 2,
                          valor: _ctx.state.imposto.cofins.aliquota,
                          "onUpdate:valor": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.imposto.cofins.aliquota) = $event)),
                          disabled: !_ctx.props.editavel
                        }, null, 8, ["valor", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_a_form_item, {
                      label: "COFINS Valor",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          monetario: true,
                          quantidadeCasasDecimais: 2,
                          valor: _ctx.state.imposto.cofins.valorCofins,
                          "onUpdate:valor": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.imposto.cofins.valorCofins) = $event)),
                          disabled: !_ctx.props.editavel,
                          onChange: _ctx.atualizarTotalTributos
                        }, null, 8, ["valor", "disabled", "onChange"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}